// extracted by mini-css-extract-plugin
module.exports = {"root":"statisticsDashboard_root__M7sGh","message":"statisticsDashboard_message__3C9g-","users__filters":"statisticsDashboard_users__filters__2kwf_"};